import React from 'react'

export default function ShortHero({title= "", description=""}) {
  return (
    <section className="mt-32 px-0 2xl:px-12">
      <h1 className="text-[13vw] uppercase mb-0 pb-0">{title}</h1>
      <div className="max-w-xl mb-12">
        <p>{description}</p>
      </div>
    </section>
  )
}
